import { api } from '@/lib/api'

import { EndContractPayload } from '../types'

export function endContract(data: EndContractPayload) {
  const { contractId, ...rest } = data

  return api.post(`/v1/me/contracts/${contractId}/end`, rest)
}
